import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { http } from "@/lib/api";

const GuestCtx = createContext(null);

export function GuestProvider({ children }) {
  const [guest, setGuest] = useState(null);
  const [stay, setStay] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await http.get("/guest/me");
      setGuest(r.data.guest);
      setStay(r.data.stay);
    } catch {
      setGuest(null);
      setStay(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = useCallback(async () => {
    await http.post("/guest/logout");
    setGuest(null);
    setStay(null);
  }, []);

  const value = useMemo(() => ({ guest, stay, loading, refresh, logout }), [guest, stay, loading, refresh, logout]);

  return <GuestCtx.Provider value={value}>{children}</GuestCtx.Provider>;
}

export const useGuest = () => useContext(GuestCtx);
